import { useSelector } from 'react-redux';
import { selectAdAccounts } from '@mm/state/selectors/adAccountsSelecotrs';
import { useEffect, useState } from 'react';
import AdSetModel from '@mm/state/model/AdSetModel';
import AdSetController from '@mm/state/controllers/AdSetController';
import AdConfigController from '@mm/state/controllers/AdConfigController';
import { AdModel } from '@mm/state/model/AdModel';
import { CURRENCY_OFFSETS } from '@mm/state/model/AdAccountModel';
import { AdSetBudgetType } from '@mm/state/interfaces/adAccounts';
import { DEFAULT_AD_SET_BUDGET } from '../../constants/constants';

export const useAdConfigFactory = ({
  onBusyStateChange = () => {},
  botId,
}: {
  onBusyStateChange?: (isBusy: boolean) => void;
  botId?: number;
} = {}) => {
  const adAccounts = useSelector(selectAdAccounts);
  const [adSets, setAdSets] = useState<AdSetModel[]>([]);
  const [ads, setAds] = useState<AdModel[]>([]);

  const account = adAccounts[0];

  useEffect(() => {
    (async () => {
      if (adAccounts.length === 0) {
        return;
      }
      onBusyStateChange(true);
      const [adSetsResponse, adsResponse] = await Promise.all([
        AdSetController.allNonDeprecated({
          accountId: account.id,
          botId,
          limit: 10,
        }),
        AdConfigController.availableAds({
          accountId: account.id,
          botId,
          limit: 10,
        }),
      ]);
      setAdSets((adSetsResponse.data as unknown as AdSetModel[]) || []);
      setAds(adsResponse.data || []);
      onBusyStateChange(false);
    })();
  }, [adAccounts.length]);

  const adSet = adSets[0];
  const ad = ads[0];

  return () => ({
    adSetBudgetType: AdSetBudgetType.DAILY,
    adSetBudget:
      DEFAULT_AD_SET_BUDGET * CURRENCY_OFFSETS[account?.currency || 'USD'],
    sourceAdSetId: adSet?.id || null,
    adAccountId: account?.id,
    adAccountName: account?.name,
    differentUser: account?.differentUser,
    sourceAdId: ad?.id || null,
    creativeText: ad?.creativeText || '',
    creativeDescription: ad?.creativeDescription || '',
    creativeHeadline: ad?.creativeHeadline || '',
    targeting: null,
  });
};
